module.exports = __webpack_public_path__ + "img/cb-f-n-rr2.d94b8a09.gif";